import disputeActionConstants from '../constants/disputeActionConstants';
import paymentActionConstants from '../constants/paymentActionConstants';

const initialState = {
  userPayments: [],
  isUserPaymentsLoading: false,
  pageInfo: null,
};

const paymentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case paymentActionConstants.GET_PAYMENTS:
      return {
        ...state,
        userPayments: [],
        pageInfo: null,
        isUserPaymentsLoading: true,
      };
    case paymentActionConstants.GET_PAYMENTS_SUCCESS:
      return {
        ...state,
        userPayments: action.payload.payouts,
        pageInfo: action.payload.page_info,
        isUserPaymentsLoading: false,
      };
    case paymentActionConstants.GET_PAYMENTS_ERROR:
      return {
        ...state,
        isUserPaymentsLoading: false,
      };
    case disputeActionConstants.CREATE_DISPUTE:
      return {
        ...state,
        isUserPaymentsLoading: true,
      };
    case disputeActionConstants.CREATE_DISPUTE_SUCCESS:
      return {
        ...state,
        userPayments: state.userPayments.map((payment) =>
          payment.id === action.payload.id ? { ...payment, disputed: action.payload.is_disputed } : payment
        ),
        isUserPaymentsLoading: false,
      };
    case disputeActionConstants.CREATE_DISPUTE_ERROR:
      return {
        ...state,
        isUserPaymentsLoading: false,
      };
    default:
      return {
        ...state,
      };
  }
};

export default paymentsReducer;
